export const EDIT_OPTION_BREAK_IN = 'breakIn';
export const EDIT_OPTION_BREAK_OUT = 'breakOut';
export const EDIT_OPTION_CHECK_OUT = 'checkOut';

export const TIME_CLOCK_STATUS_PROGRESS = 'progress';
export const TIME_CLOCK_STATUS_BREAK = 'break';
export const TIME_CLOCK_STATUS_COMPLETED = 'completed';
